import { createContext, FC } from 'react';
import Tracker from '@deliveroo/events-client';

import tracker from 'lib/utils/userTracking/tracker';

const TrackerContext = createContext<Tracker>(tracker);

interface TrackerProviderProps {
  tracker: Tracker;
}

export const TrackerProvider: FC<TrackerProviderProps> = ({
  children,
  tracker,
}) => (
  <TrackerContext.Provider value={tracker}>{children}</TrackerContext.Provider>
);

export default TrackerContext;
